const oaLogin = () => import('@/views/outerLink/oaLogin.vue')
export default [
  {
   path: '/oaLogin',
   name: 'oaLogin',
   component: oaLogin
  }
]